var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._l(_vm.breadcrumbs, function (breadcrumb) {
    return _c('b-breadcrumb-item', {
      key: breadcrumb.name,
      attrs: {
        "to": breadcrumb.to
      }
    }, [_vm._v(_vm._s(breadcrumb.name))]);
  }), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])], 2)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路名稱",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "state": _vm.v$.form.name.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "name", $$v);
      },
      expression: "state.form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.name.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路類型",
      "label-for": "type"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "type",
      "state": _vm.v$.form.type.$error ? false : null,
      "options": _vm.merchantTypes,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "type", $$v);
      },
      expression: "state.form.type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.type.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路簡稱",
      "label-for": "type-name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "type-name",
      "state": _vm.v$.form.type_name.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.type_name,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "type_name", $$v);
      },
      expression: "state.form.type_name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.type_name.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用",
      "label-for": "is_enabled"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "name": "is_enabled",
      "value": 1,
      "unchecked-value": 0,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "is_enabled", $$v);
      },
      expression: "state.form.is_enabled"
    }
  })], 1), (_vm.isShow || _vm.isEdit) && _vm.isLine ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "立即同步"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-2",
    attrs: {
      "title": "設定 LINE Messaging API Token"
    },
    on: {
      "click": _vm.updateChannelToken
    }
  }, [_vm._v(" 設定 LINE Messaging API Token ")]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-2",
    attrs: {
      "title": "更新 OA"
    },
    on: {
      "click": _vm.updateOaOnly
    }
  }, [_vm._v(" 更新 OA ")]), _vm.hasOa ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-2",
    attrs: {
      "title": "重設組織 LINE 參數"
    },
    on: {
      "click": _vm.updateOrgVariables
    }
  }, [_vm._v(" 重設組織 LINE 參數 ")]) : _vm._e(), _c('br'), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-2",
    attrs: {
      "title": "更新好友"
    },
    on: {
      "click": _vm.updateFriends
    }
  }, [_vm._v(" 更新好友 ")]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-2",
    attrs: {
      "title": "建立組織 LIFF"
    },
    on: {
      "click": _vm.updateOrCreateLineLiff
    }
  }, [_vm._v(" 建立組織 LIFF ")]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-2",
    attrs: {
      "title": "設定組織 Webhook"
    },
    on: {
      "click": _vm.updateLineWebhook
    }
  }, [_vm._v(" 設定組織 Webhook ")])], 1) : _vm._e(), (_vm.isShow || _vm.isEdit) && _vm.isLine ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Webhook 網址"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2",
    attrs: {
      "type": "text",
      "disabled": true,
      "value": "".concat(_vm.webhookHost, "/line/").concat(_vm.merchantId)
    }
  }), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": true,
      "value": "".concat(_vm.webhookHost, "/cresclab/").concat(_vm.merchantId)
    }
  })], 1) : _vm._e(), (_vm.isShow || _vm.isEdit) && _vm.isLine ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "LIFF Endpoint URL"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2",
    attrs: {
      "type": "text",
      "disabled": true,
      "value": "".concat(_vm.host, "/").concat(_vm.organization.code, "/liff/")
    }
  })], 1) : _vm._e(), (_vm.isShow || _vm.isEdit) && _vm.isLine ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "LINE OA ID"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2",
    attrs: {
      "type": "text",
      "disabled": true,
      "value": _vm.lineOaId ? "@".concat(_vm.lineOaId) : '未設定'
    }
  })], 1) : _vm._e(), (_vm.isShow || _vm.isEdit) && _vm.isLine ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "LINE OA URL"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2",
    attrs: {
      "type": "text",
      "disabled": true,
      "value": _vm.lineOaId ? "https://line.me/R/ti/p/@".concat(_vm.lineOaId) : '未設定'
    }
  })], 1) : _vm._e(), (_vm.isShow || _vm.isEdit) && _vm.isLine ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "LINE LIFF 網址"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2",
    attrs: {
      "type": "text",
      "disabled": true,
      "value": _vm.lineLiffId ? "https://liff.line.me/".concat(_vm.lineLiffId, "/") : '未設定'
    }
  })], 1) : _vm._e()], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("取消")]), !_vm.isShow ? _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "確認修改" : "確認新增") + " ")])], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }